export default __webpack_public_path__ + "static/media/BluesForMaPuce60s.92b4c300.mp3";